<template>
  <Tooltip
    class="sustainability-leaf group relative ml-2 cursor-pointer"
    type="success"
  >
    <SpriteSymbol
      name="sustainability"
      class="size-[0.8em] translate-y-[0.1em] transition ease-swing group-hover:scale-110"
    />
    <template #content>
      <div class="sustainability-leaf-info">
        {{ title }}
      </div>
    </template>
  </Tooltip>
</template>

<script lang="ts" setup>
const { $texts } = useEasyTexts()
const title = computed(() =>
  $texts(
    'sustainabilityLeaf',
    'The green leaf symbol identifies offers (venues, hotels, restaurants, or tours) that offset emissions via the myclimate foundation, are recognized in the GDS index, are Swisstainable Level III-certified, or are making extraordinary efforts in terms of sustainability.',
  ),
)
</script>
